module.exports = __webpack_public_path__ + "img/girl.17e871c4.png";